<template>
    <Link
        :class="[$style.link, { [$style.selected]: props.isSelected }]"
        data-interface-target="switch-locale"
        :to="props.href"
        color="white-60"
        :disabled="props.isSelected"
        @click="emit('click', props.locale)"
    >
        <Icon
            :name="locale"
            :alt="`switch_to_${localeName}`"
            :class="$style.icon"
        />
        <Typography
            type="label"
            size="xs"
            :responsive="false"
        >
            {{ localeName }}
        </Typography>
    </Link>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import Icon from '@/components_new/Icon/Icon.vue'
import Link from '@/components_new/Link.vue'
import Typography from '@/components_new/Typography.vue'
import { LOCALE_TITLES } from '@/i18n/helpers'
import { AvailableLocale } from '@/i18n/types'

interface LocaleSwitcherProps {
    locale: AvailableLocale
    href: string
    isSelected: boolean
}

const props = defineProps<LocaleSwitcherProps>()

const emit = defineEmits<{
    click: [locale: AvailableLocale]
}>()

const localeName = computed(() => LOCALE_TITLES[props.locale])
</script>

<style module>
.link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    border-radius: 1000px;
    padding: 6px 12px 6px 6px;
    --main: var(--black);
    --border-color: var(--carbon-400);
    background-color: var(--main);
    border: 1px solid var(--border-color);
}

.selected {
    cursor: default;
}

.link:hover {
    --border-color: var(--carbon-500);
}

.link:active,
.link.selected {
    color: var(--white);
    --border-color: var(--carbon-400);
    --main: var(--carbon-400);
}

.link:focus-visible {
    --border-color: var(--carbon-500);
}

.icon {
    width: 24px;
    height: 24px;
}
</style>
